import { useRef, useState, useEffect } from 'react'
import clsx from 'clsx'
import { FaSearch } from 'react-icons/fa'
import { RxCross1 } from 'react-icons/rx'

import Filler from '../../components/utils/Filler'
import { UserSimple } from '../../services/schema/User'
import { useGetUserSearchedQuery } from '../../services/apiSlice'
import { Link } from 'react-router'

const Explore: React.FC = () => {
  const inputRef = useRef<HTMLDivElement>(null)
  const [searchInput, setSearchInput] = useState<string>('')
  const [filteredUsers, setFilteredUsers] = useState<UserSimple[]>([])

  const [inputIsFocused, setInputIsFocused] = useState<boolean>(false)

  const { data, isSuccess } = useGetUserSearchedQuery(null)

  useEffect(() => {
    setSearchInput('')
  }, [])

  useEffect(() => {
    const inputRefCurrent = inputRef.current
    if (inputRefCurrent) {
      const handleClickOutsideInput = (event: MouseEvent) => {
        const target = event.target as Node

        const clickedOutsideInput =
          inputRefCurrent && !inputRefCurrent.contains(target)

        if (clickedOutsideInput) {
          setInputIsFocused(false)
        }
      }

      document.addEventListener('mousedown', handleClickOutsideInput)
      return () => {
        document.removeEventListener('mousedown', handleClickOutsideInput)
      }
    }
  }, [inputRef])

  if (data && isSuccess) {
    const users = data.users

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const inputQuery = event.target.value
      setSearchInput(inputQuery)

      let filteredData = users.filter((user) => {
        if (
          inputQuery === '' ||
          !user.username.toLowerCase().includes(inputQuery.toLowerCase())
        ) {
          return
        } else {
          return user
        }
      })

      if (filteredData.length > 10) {
        filteredData.splice(10)
        setFilteredUsers(filteredData)
      } else if (filteredData.length === 0 || inputQuery === '') {
        setFilteredUsers([])
      } else {
        setFilteredUsers(filteredData)
      }
    }

    return (
      <>
        <div className="relative flex w-full grow">
          <div className="bgd-theme flex h-dvh w-full max-w-[600px] min-w-0 grow flex-col items-stretch md:mr-0">
            <Filler />
            <div className="flex max-w-[600px] bg-inherit text-xl font-bold">
              <div className="bgd-theme flex w-full flex-col items-center">
                <div className="bgd-theme border-theme sticky top-0 flex h-[10dvh] w-full items-center border-r border-l pr-[30px] pl-[20px]">
                  <form
                    className={clsx(
                      'relative flex h-[50px] w-full items-center rounded-full',
                      {
                        'border-blue bgd-theme border border-solid':
                          inputIsFocused,
                        'border-theme bgd-theme border border-solid':
                          !inputIsFocused,
                      },
                    )}
                  >
                    <div className="flex h-full w-[50px] items-center justify-end">
                      <FaSearch
                        className={clsx('', {
                          'text-sub': !inputIsFocused,
                          'text-blue': inputIsFocused,
                        })}
                      />
                    </div>
                    <div
                      ref={inputRef}
                      className="relative flex h-full w-full"
                      onFocus={() => {
                        setInputIsFocused(true)
                      }}
                      onBlur={() => {
                        setInputIsFocused(false)
                      }}
                    >
                      <input
                        className={clsx(
                          'flex h-full w-full grow rounded-full border-none bg-inherit pl-[15px] text-sm outline-none focus:ring-0 focus:outline-none',
                          {
                            'pr-[20px]': !inputIsFocused,
                            'pr-[40px]': inputIsFocused,
                          },
                        )}
                        placeholder="Search"
                        type="text"
                        value={searchInput}
                        onChange={(event) => {
                          handleInputChange(event)
                        }}
                      />
                      {inputIsFocused && searchInput.length > 0 && (
                        <button
                          className="bgd-blue absolute top-[50%] right-[15px] h-[20px] translate-y-[-50%] cursor-pointer rounded-full p-[3px] text-sm font-bold text-white"
                          type="button"
                          data-typeid="clear-search-btn"
                          onClick={() => {
                            setSearchInput('')
                            setFilteredUsers([])
                          }}
                        >
                          <RxCross1 />
                        </button>
                      )}
                    </div>
                  </form>
                </div>

                <Filler />
                <div className="border-theme flex min-h-[90dvh] w-full grow flex-col border-r border-b border-l">
                  {filteredUsers.map((user) => {
                    const profilePic =
                      user.profilePicture !== null
                        ? user.profilePicture
                        : '/user_sample.jpg'
                    return (
                      <Link
                        to={`/${user.username}`}
                        key={user.username + user.displayName}
                        className="hover-sub flex h-[80px] items-center text-sm"
                      >
                        <div className="flex w-[80px] items-center justify-center px-[15px]">
                          <img
                            src={profilePic}
                            width={30}
                            height={30}
                            className="h-[40px] w-[40px] rounded-full"
                            alt=""
                          />
                        </div>
                        <div className="pl-[15px]">
                          <div className="flex flex-col">
                            <p>{user.displayName}</p>
                            <p className="text-sub">@{user.username}</p>
                          </div>
                        </div>
                      </Link>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Explore
